// extracted by mini-css-extract-plugin
export default {"row":"TableRow_row__QpUEV","cell":"TableRow_cell__5geP9"};